
<!-- 


    -------------------------------------------------

    DEPRECATED - DO NOT USE FOR NEW DEVELOPMENT

    -------------------------------------------------
    

    
-->
<template>
    <component :is="'h' + level">
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: 'TextHeader',
    props: {
        level: {
            type: Number,
            required: true
        },
    },
    data () {
        return { };
    }
};
</script>